import { DatePicker, DatePickerProps } from 'antd';
import { Dayjs } from 'dayjs';
import { CellRender } from 'rc-picker/es/interface';
import React, { FC, memo, ReactNode, useCallback } from 'react';
import { getLunarDate } from 'utils/moment/convertSolarToLunar';
import dayjs from 'utils/moment/dayjsConfig';
import 'dayjs/locale/vi';
import { DEFAULT_DATE_FORMAT } from 'utils/moment/utils';
import style from './LunarDatePicker.module.scss';

const LunarDatePicker: FC<DatePickerProps> = props => {
  const renderAntPickerCell = useCallback((current: Dayjs): ReactNode => {
    const currentDate = dayjs(current).get('date');
    const currentMonth = dayjs(current).get('month') + 1;
    const currentYear = dayjs(current).get('year');

    const currentLunarDate = getLunarDate(
      currentDate,
      currentMonth,
      currentYear
    );
    const { day, month } = currentLunarDate;
    return (
      <div className="ant-picker-cell-inner">
        <span className="solar-day">{current.date()}</span>
        {day === 1 ? (
          <span className="lunar-day highlight">
            {day}/{month}
          </span>
        ) : (
          <span className="lunar-day">{day}</span>
        )}
      </div>
    );
  }, []);

  const cellRender = useCallback(
    (current: Dayjs) => renderAntPickerCell(current),
    [renderAntPickerCell]
  );

  return (
    <DatePicker
      className={style.customLunarDatePicker}
      format={DEFAULT_DATE_FORMAT}
      getPopupContainer={(trigger: HTMLElement) => trigger}
      cellRender={cellRender as CellRender<Dayjs>}
      {...props}
    />
  );
};

export default memo(LunarDatePicker);
